export default __webpack_public_path__ + "static/filemark-47aa46948d9a5092926ebdb30b28f9d0.png";